import { SystemIcon } from '@helpers/icons';
import { LinkButton } from '@stories/Components/Buttons/Button/Button';
import HighlightTitle from '@stories/Components/Misc/HighlightTitle/HighlightTitle';
import { ContentType } from '@stories/Components/Misc/SectionWrapper/SectionWrapper';
import { debounce } from 'lodash';
import * as React from 'react';
import S from './InnerHeroBanner.styles';
import { getSrcs } from '@helpers/image';
import { useMedia } from 'react-use';
import { Device, until } from '@helpers/media';
import { useCookies } from 'react-cookie';
const InnerHeroBanner = (props) => {
    const image1Src = props.image1 ? getSrcs(props.image1, 408, 164, 4, 4 / 5) : null;
    const image2Src = props.image2 ? getSrcs(props.image2, 408, 164, 4, 4 / 5) : null;
    const contentRef = React.useRef(null);
    const [readAll, setReadAll] = React.useState(false);
    const [showReadMore, setShowReadMore] = React.useState(false);
    const onResize = React.useCallback(debounce(checkReadMore, 100), []);
    const isMobile = useMedia(until(Device.Tablet), false);
    // Used to determine if the Usp bar is active in the header and adjust the padding accordingly
    const topPaddingDefault = isMobile ? 100 : 280;
    const [sentTopPadding, setTopPadding] = React.useState(topPaddingDefault);
    const cookieName = props.cookieName ?? 'notice-cookie';
    const [cookies] = useCookies([cookieName]);
    React.useEffect(() => {
        const headerUspElement = document.getElementById('headerUsp');
        if (headerUspElement) {
            setTopPadding(headerUspElement.getBoundingClientRect().height + topPaddingDefault);
        }
    }, [isMobile, cookies[cookieName]]);
    React.useEffect(() => {
        onResize();
        window.addEventListener('resize', onResize);
        return () => {
            window.removeEventListener('resize', onResize);
        };
    }, []);
    return (React.createElement(S.Wrapper, { "data-background": props.theme },
        props.contentType === ContentType.Engage && !props.image1 && React.createElement(S.EngageShapeLeft, null),
        React.createElement(S.Container, { "data-background": props.theme, "data-type": props.contentType ?? ContentType.Default, "data-read-all": readAll, style: { '--paddingTop': `${sentTopPadding}px` }, translations: props.translations, id: props.anchorId },
            image1Src && image1Src.src && (React.createElement(S.ImageContainerLeft, null,
                React.createElement(S.Image, { src: image1Src.src, srcSet: image1Src.srcSet, alt: props.image1?.altText, role: props.image1?.altText ? undefined : 'presentation', loading: 'eager' }))),
            React.createElement(S.ContentContainer, null,
                props.title && (React.createElement(S.TitleContainer, null,
                    React.createElement(HighlightTitle, { theme: props.theme, title: props.title, contentType: props.contentType, tagType: "h1" }))),
                React.createElement(S.Content, { ref: contentRef, dangerouslySetInnerHTML: { __html: props.introduction } }),
                React.createElement(S.ReadMore, { onClick: () => setReadAll(true), "data-active": showReadMore && !readAll }, props.translations?.['global.readMore']),
                React.createElement(S.CTAsContainer, null,
                    props.cta && (React.createElement(LinkButton, { buttonType: props.cta.brandColor ?? 'teal', href: props.cta.url, target: props.cta.target, icon: props.cta.icon ?? SystemIcon.ArrowRightThin, "aria-label": props.cta.text }, props.cta.text)),
                    props.cta2 && (React.createElement(LinkButton, { buttonType: props.cta2.brandColor ?? 'teal', href: props.cta2.url, target: props.cta2.target, icon: props.cta2.icon ?? SystemIcon.ArrowRightThin, "aria-label": props.cta2.text }, props.cta2.text)))),
            image2Src && image2Src.src && (React.createElement(S.ImageContainerRight, null,
                React.createElement(S.Image, { src: image2Src.src, srcSet: image2Src.srcSet, alt: props.image2?.altText, role: props.image2?.altText ? undefined : 'presentation', loading: 'eager' })))),
        props.contentType === ContentType.Engage && !props.image2 && React.createElement(S.EngageShapeRight, null)));
    function checkReadMore() {
        if (!contentRef.current) {
            return;
        }
        if (contentRef.current.scrollHeight > contentRef.current.clientHeight) {
            return setShowReadMore(true);
        }
        return setShowReadMore(false);
    }
};
export default InnerHeroBanner;
